import { z } from "zod";

// Graceful client-side waitlist capture.
// TODO(cloud): wire to Lovable Cloud `waitlist` table once enabled.
const schema = z.object({
  email: z.string().trim().toLowerCase().email().max(255),
  state: z.string().min(2).max(2),
});

export type WaitlistEntry = { email: string; state: string; createdAt: string };

const KEY = "olive.waitlist.v1";

export async function joinWaitlist(input: { email: string; state: string }): Promise<{ ok: true } | { ok: false; error: string }> {
  const parsed = schema.safeParse(input);
  if (!parsed.success) {
    return { ok: false, error: parsed.error.issues[0]?.message ?? "Invalid email" };
  }
  try {
    const list: WaitlistEntry[] = JSON.parse(localStorage.getItem(KEY) || "[]");
    list.push({ email: parsed.data.email, state: parsed.data.state, createdAt: new Date().toISOString() });
    localStorage.setItem(KEY, JSON.stringify(list));
    // Best-effort beacon for analytics/CRMs that listen for this event.
    if (typeof window !== "undefined" && (window as unknown as { dataLayer?: unknown[] }).dataLayer) {
      (window as unknown as { dataLayer: unknown[] }).dataLayer.push({
        event: "waitlist_join",
        state: parsed.data.state,
      });
    }
    return { ok: true };
  } catch {
    return { ok: false, error: "Could not save. Please try again." };
  }
}
